// ── Pre-built form templates ───────────────────────────────────────────────
// Each template matches the FormBuilder initialData shape (no _id = new form)

const FORM_TEMPLATES = [
  // ── 1. ויתור סודיות ─────────────────────────────────────────────────────
  {
    _templateId: "confidentiality",
    icon: "🔒",
    description: "אישור לקוח לשימוש במידע האישי שלו לצורכי הטיפול",
    title: "ויתור סודיות",
    type: "declaration",
    hasSignature: true,
    signatureType: "both",
    includeClientName: true,
    includeClientPhone: true,
    requiresResubmission: false,
    questions: [],
    content: `כתב ויתור על סודיות והרשאה לשימוש במידע

אני החתום/ה מטה מאשר/ת ומרשה בזאת לעסק ולצוות העובדים מטעמו, לשמור, לעבד ולעשות שימוש במידע האישי שנמסר על ידי לצורכי מתן השירות בלבד.

המידע שנמסר כולל: פרטים אישיים, היסטוריה רפואית רלוונטית, ותיעוד טיפולים/פגישות שנערכו עמי.

אני מצהיר/ה כי:
• קראתי והבנתי את תנאי ויתור הסודיות.
• המידע שנמסר יישמר בסודיות ולא יועבר לצד שלישי ללא הסכמתי, אלא כנדרש על פי חוק.
• אני רשאי/ת לבקש עיון במידע המאוחסן אודותי בכל עת.
• אני זכאי/ת לבטל הרשאה זו בהודעה בכתב, ללא פגיעה בשירות שניתן לי עד למועד הביטול.

הצהרה זו עומדת בהתאם לחוק הגנת הפרטיות, התשמ"א-1981 ותקנות הגנת הפרטיות (אבטחת מידע), תשע"ז-2017.`,
  },

  // ── 2. הצהרת בריאות ─────────────────────────────────────────────────────
  {
    _templateId: "health",
    icon: "❤️",
    description: "הצהרת בריאות לפעילות גופנית, טיפולים ושירותי רווחה",
    title: "הצהרת בריאות",
    type: "declaration",
    hasSignature: true,
    signatureType: "both",
    includeClientName: true,
    includeClientPhone: false,
    requiresResubmission: true,
    questions: [],
    content: `הצהרת בריאות

אני החתום/ה מטה מצהיר/ה כי מצבי הבריאותי מאפשר לי לקבל את השירות/לעסוק בפעילות המוצעת, וכי לא קיימת מניעה רפואית לכך.

אני מצהיר/ה כי:
• אינני סובל/ת ממחלת לב ידועה, ולא קיבלתי הנחיה רפואית להגביל פעילות.
• אינני סובל/ת מיתר לחץ דם שאינו מאוזן.
• אינני חולה סוכרת שאינה מאוזנת.
• אינני סובל/ת מהפרעת קצב לב ידועה.
• אינני נמצא/ת בתקופת הריון (במידה ורלוונטי).
• לא עברתי ניתוח בשלושת החודשים האחרונים.
• אינני סובל/ת מבעיית אורתופדית/שרירית-שלדית המונעת ממני את הפעילות.

אלרגיות ידועות / תרופות קבועות / מגבלות נוספות:
________________________________________

ידוע לי כי עלי לעדכן את נותן השירות בכל שינוי במצב בריאותי.
ידוע לי כי הצהרה זו תחודש אחת לשנתיים.

הצהרה זו נערכת בהתאם לחוק מכוני כושר (רישוי ופיקוח), תשנ"ד-1994 ותקנותיו.`,
  },

  // ── 3. כתב ויתור ושחרור מאחריות ─────────────────────────────────────────
  {
    _templateId: "liability",
    icon: "⚖️",
    description: "שחרור העסק מאחריות לנזקים שעלולים להיגרם במהלך הפעילות",
    title: "כתב ויתור ושחרור מאחריות",
    type: "declaration",
    hasSignature: true,
    signatureType: "both",
    includeClientName: true,
    includeClientPhone: false,
    requiresResubmission: false,
    questions: [],
    content: `כתב ויתור ושחרור מאחריות

אני החתום/ה מטה, מבקש/ת להשתתף בפעילות/לקבל שירות מהעסק.

הצהרת מודעות לסיכונים:
אני מצהיר/ה כי אני מודע/ת לכך שהפעילות/השירות עשויים להיות כרוכים בסיכונים פיזיים. אני מאשר/ת כי אני משתתף/ת בפעילות מרצוני/ת החופשי/ת.

ויתור על תביעות:
הריני מוותר/ת על כל טענה, זכות ועילת תביעה כלפי העסק, עובדיו ומי שפועל מטעמו, בגין כל נזק גוף או רכוש שייגרם כתוצאה מהשתתפותי בפעילות, למעט נזק שייגרם כתוצאה מרשלנות רבתי או מעשה מכוון.

הצהרת כשירות:
• אני כשיר/ה רפואית להשתתף בפעילות.
• לא נאסר עלי על ידי רופא להשתתף בפעילות מסוג זה.
• אני אחראי/ת לכל ציוד אישי שאביא לפעילות.

אני מתחייב/ת לפעול לפי כל הוראות הבטיחות שיינתנו על ידי הצוות.

ידוע לי כי מסמך זה מהווה כתב ויתור משפטי מחייב ואני חותם/ת עליו מרצוני/ת החופשי/ת.

(בהתאם לחוק החוזים (חלק כללי), תשל"ג-1973 ופקודת הנזיקין)`,
  },

  // ── 4. הסכמה לטיפול ─────────────────────────────────────────────────────
  {
    _templateId: "consent",
    icon: "✅",
    description: "הסכמה מדעת לקבלת טיפול - קוסמטיקה, פיזיותרפיה, רפואה משלימה ועוד",
    title: "הסכמה לטיפול",
    type: "declaration",
    hasSignature: true,
    signatureType: "both",
    includeClientName: true,
    includeClientPhone: true,
    requiresResubmission: false,
    questions: [],
    content: `טופס הסכמה מדעת לטיפול

סוג הטיפול: ________________________________________
מטרת הטיפול: ________________________________________

הוסבר לי על ידי המטפל/ת:
• תיאור הטיפול, מטרותיו והליך ביצועו.
• היתרונות הצפויים מהטיפול.
• הסיכונים, תופעות הלוואי האפשריות והמגבלות הידועות.
• חלופות לטיפול המוצע, לרבות האפשרות שלא לקבל טיפול.

הצהרה:
אני מצהיר/ה כי:
• קיבלתי הסבר מפורט ומספק על הטיפול המוצע ומשמעויותיו.
• ניתנה לי הזדמנות לשאול שאלות ולקבל מענה מלא.
• הבנתי את המידע שנמסר לי.
• מסרתי מידע מלא ונכון על מצבי הרפואי, התרופות שאני נוטל/ת וכל מגבלה רלוונטית.
• אני נותן/ת הסכמתי מדעת ומרצוני/ת החופשי/ת לקבלת הטיפול המתואר.

ידוע לי שאני רשאי/ת לחזור בי מהסכמתי בכל עת, ועדיין אקבל טיפול חלופי ככל האפשר.

(בהתאם לחוק זכויות החולה, התשנ"ו-1996, סעיף 13 - הסכמה מדעת)`,
  },

  // ── 5. שאלון לקוח חדש ───────────────────────────────────────────────────
  {
    _templateId: "intake",
    icon: "📋",
    description: "שאלון קבלת לקוח חדש - פרטים אישיים, מצב בריאות ומטרות",
    title: "שאלון לקוח חדש",
    type: "questionnaire",
    hasSignature: true,
    signatureType: "checkbox",
    includeClientName: true,
    includeClientPhone: true,
    requiresResubmission: false,
    content: "",
    questions: [
      { id: "tpl_q1", text: "מה גילך?", type: "short_text", required: true, options: [], order: 0 },
      { id: "tpl_q2", text: "כיצד הגעת אלינו?", type: "single_choice", required: false, options: ["המלצת חבר/ה", "גוגל", "רשתות חברתיות", "שלט / פרסום", "אחר"], order: 1 },
      { id: "tpl_q3", text: "האם את/ה סובל/ת ממחלת לב או לחץ דם גבוה?", type: "yes_no", required: true, options: [], order: 2 },
      { id: "tpl_q4", text: "האם את/ה חולה סוכרת?", type: "yes_no", required: true, options: [], order: 3 },
      { id: "tpl_q5", text: "האם את/ה נוטל/ת תרופות קבועות? אם כן, פרט/י", type: "long_text", required: false, options: [], order: 4 },
      { id: "tpl_q6", text: "האם יש לך אלרגיות ידועות? אם כן, פרט/י", type: "long_text", required: false, options: [], order: 5 },
      { id: "tpl_q7", text: "האם עברת ניתוח בשנה האחרונה?", type: "yes_no", required: true, options: [], order: 6 },
      { id: "tpl_q8", text: "האם את/ה בהריון או מניקה?", type: "yes_no", required: false, options: [], order: 7 },
      { id: "tpl_q9", text: "מה מטרת הביקור שלך?", type: "long_text", required: true, options: [], order: 8 },
      { id: "tpl_q10", text: "האם עברת טיפולים דומים בעבר?", type: "yes_no", required: false, options: [], order: 9 },
      { id: "tpl_q11", text: "האם חווית תגובה שלילית לטיפול כלשהו בעבר? אם כן, פרט/י", type: "long_text", required: false, options: [], order: 10 },
      { id: "tpl_q12", text: "רמת הפעילות הגופנית השבועית שלך", type: "single_choice", required: false, options: ["לא מתאמן/ת", "1-2 פעמים בשבוע", "3-4 פעמים בשבוע", "5+ פעמים בשבוע"], order: 11 },
      { id: "tpl_q13", text: "ציין/י הערות נוספות או כל מידע שחשוב שנדע", type: "long_text", required: false, options: [], order: 12 },
    ],
  },
];

export default FORM_TEMPLATES;
